const LOGIN_PATH = '/connect'
const INTENDED_PATH_KEY = 'login:intended_path'

/**
 * Not worth remembering: the login page itself (a second redirect while on
 * it must keep the original page) and the root, which is no specific page
 * and would replace the usual landing dashboard.
 */
const IGNORED_PATHS = [LOGIN_PATH, '/']

/**
 * Remembers the page to open after login.
 */
export function rememberIntendedPath(path: string): void {
  try {
    if (
      IGNORED_PATHS.includes(new URL(path, window.location.origin).pathname)
    ) {
      return
    }

    sessionStorage.setItem(INTENDED_PATH_KEY, path)
  } catch {
    // sessionStorage unavailable (private mode): login falls back to the dashboard
  }
}

/**
 * Page remembered before login, removed so it is followed only once.
 */
export function pullIntendedPath(): string | null {
  try {
    const path = sessionStorage.getItem(INTENDED_PATH_KEY)
    sessionStorage.removeItem(INTENDED_PATH_KEY)

    return path
  } catch {
    return null
  }
}

/**
 * Drops a remembered page once the user is in the app, so a later login
 * (another user, end of impersonation) does not follow it.
 */
export function forgetIntendedPath(): void {
  try {
    sessionStorage.removeItem(INTENDED_PATH_KEY)
  } catch {
    // sessionStorage unavailable: nothing was remembered
  }
}

/**
 * Full reload to the login page, remembering the current page. Used outside
 * the router, when the session is gone.
 */
export function redirectToLogin(): void {
  const { pathname, search, hash } = window.location
  rememberIntendedPath(pathname + search + hash)

  if (pathname !== LOGIN_PATH) {
    window.location.href = LOGIN_PATH
  }
}
